import { Box, styled, Typography } from '@mui/material';
import { CalendarDay } from 'further-ui/utils';
import { differenceInCalendarDays } from 'date-fns';

type Props = {
  dueDate: CalendarDay;
};

const Banner = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.lightWarning,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const BannerText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const OverdueBanner: React.FC<Props> = ({ dueDate }) => {
  const daysOverdue = differenceInCalendarDays(
    new CalendarDay(new Date()).toUTCDate(),
    dueDate.toUTCDate(),
  );

  return (
    <Banner>
      <BannerText variant="body2">
        You have a period-end review that is overdue by {daysOverdue} day
        {daysOverdue === 1 ? '' : 's'}.
      </BannerText>
    </Banner>
  );
};

export default OverdueBanner;
